import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { getUser } from '../../actions/userAction';
import { updateData, newSimulation, exitSimulation, toggleTimelineActive } from '../../actions/dataAction';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import ReactTooltip from 'react-tooltip'

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

const SliderContainer = styled.div`
  & > div, p {
    ${props => props.inactive && css`
      opacity: 0.4;
    `}
  }
`;

const SliderValues = styled.div`
   border-top: 1px solid #5e6061;
   border-bottom: 1px solid #6e6061;
   padding: 5px 0;
   margin-bottom:10px;
`;

const SliderValue = styled.p`
   margin: 0;
   text-align:center;
   color: #ee5a5d;
   color: #f87832;
   font-size: 9px;

   &:first-child {
      color: #9f9f9f;
   }

   &:last-child {
      color: #5ab99a;
   }

   @media only screen and (max-width: 1150px) {
     font-size: 8px;
   }

   @media only screen and (max-width: 991px) {
     font-size: 12px;
   }

   @media only screen and (max-width: 424px) {
     font-size: 12px;
   }
`;

const SliderLabel = styled(Link)`
   text-align: center;
   color: #fff;
   display: block;
   margin-top:12px;
   margin-bottom:12px;
   cursor: default;
   font-size: 14px;

   &:hover, &:active, &:focus {
     color:#fff;
     text-decoration: none;
   }

   ${props => props.linked && css`
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  `}

  @media only screen and (max-width: 1320px) {
    font-size: 12px;
  }

  @media only screen and (max-width: 1150px) {
    font-size: 10px;
  }

  @media only screen and (max-width: 991px) {
    font-size: 14px;
  }
`;

const SliderWeightLabel = styled.p`
   text-align:center;
   color: #eee;
   cursor: pointer;
   font-size: 11px;
`;

const SliderScaleLabel = styled.p`
   text-align:left;
   color: #fff;
   position: relative;
   left: 20px;
   top: -7px;
`;

const ScoreTooltip = styled.div`
  border-radius: 3px;
  background: #fff;
  position: relative;
  top: 6px;
  left: -66px;
  font-size: 10px;
  padding: 0px 3px;
  width: fit-content;
  font-weight: bold;
  color: #5ab99a;

  ${props => props.active && css`
    color: #9f9f9f;
  `}

`;

const StyledReactTooltip = styled(ReactTooltip)`
  color:#555 !important;
  background-color:#fff !important;
  opacity: 1 !important;
`;

const TooltipTitle = styled.h5`
  margin: 0;
  margin-bottom:5px;
  text-transform: uppercase;

  ${props => props.small && css`
    font-size: 9px;
    margin-bottom: 0;
    font-weight: normal;
  `}
`;

const TooltipWeightLabel = styled.span`
  display: block;
  font-weight: normal;
`;

const TooltipPLabel = styled.span`
  display: block;
`;

const TooltipImpactLabel = styled.span`
  margin-top: 5px;
  display: block;
  font-weight:bold;
`;


class TelescopeSlider extends Component {
    constructor(props) {
      super(props);
    }

    sliderChange = (score, sliderValue, id) => {
      this.props.updateData({id: id, score: score, sliderValue: sliderValue, deltaScore: (sliderValue - score), active: true});
    }

    toggleSliderActive = (sliderValue, id, active) => {
      this.props.updateData({id: id, sliderValue: sliderValue, active: !active});
    }



    tooltipMark(value, active) {
      let marks = {};

      let val = parseFloat(value).toFixed(1);
      if (val % 1 === 0) {
        val = parseInt(val);
      };
      marks[val] = {
        style: {},
        label: <ScoreTooltip active={active}>{value}</ScoreTooltip>
      }

      return marks;
    }

    tooltip(dp, allDps) {
      const telescope = this.props.data.telescope;
      const Ps = [];
      const pWeights = [];

      allDps.forEach(p => {
        if (dp.id !== "total" && p.id !== "total" && dp.id != p.id) {
          let baseInput = {};
          let deltaInput = {};
          baseInput[dp.apiId] = 0;
          deltaInput[dp.apiId] = 1;

          if (dp.apiId) {
            const basePrediction = telescope.predict(baseInput);
            const deltaPrediction = telescope.predict(deltaInput);
            const baseCoeff = basePrediction[p.apiId];
            const deltaCoeff = deltaPrediction[p.apiId];

            const coeff = deltaCoeff - baseCoeff;

            if (!isNaN(coeff)) {
              Ps.push(<TooltipPLabel key={p.name}>{p.name}: {parseFloat(coeff).toFixed(2)}</TooltipPLabel>);
            }
          }
        }
      });

      if (dp.id === "total") {
        allDps.forEach(p => {
          if (p.id !== "total" && p.name && !isNaN(p.adjustedWeight)) {
            pWeights.push(<TooltipPLabel key={p.name}>{p.name}: {parseFloat(p.adjustedWeight).toFixed(1)}%</TooltipPLabel>);
          }
        });

        return(
          <StyledReactTooltip id={dp.id} effect="solid">
            <TooltipTitle small>BRAND</TooltipTitle>
            <TooltipTitle>{dp.name}</TooltipTitle>
              <TooltipImpactLabel>Impacted by: </TooltipImpactLabel>
              {pWeights}
          </StyledReactTooltip>
        );
      }

      return(
        <StyledReactTooltip id={dp.id} effect="solid">
          <TooltipTitle small>PARAMETER</TooltipTitle>
          <TooltipTitle>{dp.name}</TooltipTitle>
            <TooltipWeightLabel>Weight: {dp.adjustedWeight}%</TooltipWeightLabel>
            <TooltipImpactLabel>Impact on: </TooltipImpactLabel>
            {Ps}
        </StyledReactTooltip>
      );
    }

    isValidNumber(number) {
      return typeof(number) === 'number' && !isNaN(number)
    }

    render() {
        const { dp, options } = this.props;

        return (
          <SliderContainer className="sliderBar" style={{position:'absolute',top:'35px',bottom:'135px',left:((options.sliderOffset*dp.offset)+'%'), width:(options.sliderOffset + '%'), order: (dp.offset)}} key={dp.id} inactive={dp.inactive}>

            <div style={{display:'block'}}>
              <SliderValues inactive={dp.inactive}>
                <SliderValue>{!dp.inactive && dp.active ? dp.sliderValue : '-'}</SliderValue>
                <SliderValue>{!dp.inactive ? dp.target : '-'}</SliderValue>
                <SliderValue>{dp.inactive ? '-':(dp.active ? options.score : options.scoreSliderValue)}</SliderValue>
              </SliderValues>
            </div>

             <Range disabled min={options.sliderMinVal} max={options.sliderMaxVal} vertical count={1} marks={options.marks} value={dp.inactive ? []:[Number(options.sliderMinVal), Number(dp.target)]} pushable
                    trackStyle={[{ backgroundColor: '#fa7823' }]}
                    railStyle={{ backgroundColor: 'white' }} />

            {!dp.inactive && this.isValidNumber(dp.score) && (
              <Slider
                vertical
                disabled={!this.props.data.simulationMode || dp.blockSlider}
                value={Number(options.scoreSliderValue)}
                min={Number(options.sliderMinVal)}
                max={Number(options.sliderMaxVal)}
                step={options.sliderStepSize}
                marks={this.tooltipMark(options.scoreSliderValue, dp.active)}
                className={dp.active ? "simulationSlider active" : "simulationSlider"}
                trackStyle={[{backgroundColor:dp.active ? '#9f9f9f':'#5ab99a'}]}
                railStyle={{ backgroundColor: 'transparent' }}
                style={{position:'absolute',top:'60px'}}
                onChange = {(sliderValue) => this.sliderChange(dp.score || 0, sliderValue, dp.id)}
                onBeforeChange = {(sliderValue) => this.toggleSliderActive(sliderValue, dp.id, dp.active)}
              />
            )}
            <SliderLabel linked={dp.id !== "total"} to={dp.id !== "total" ? "/p/" + dp.id : "#"} style={{textTransform:'capitalize'}} onClick={() => this.props.toggleTimelineActive(false)}>{dp.name}</SliderLabel>

            {!dp.inactive && this.tooltip(dp, options.dataPoints)}
            <SliderWeightLabel inactive={dp.inactive} data-for={dp.id} data-tip="a" >{dp.inactive ? "-" : (dp.id === 'total' ? 100 : (isNaN(parseFloat(dp.adjustedWeight)) ? '-':dp.adjustedWeight))}%</SliderWeightLabel>
          </SliderContainer>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        data: state.data,
        user: state.user
    };
}

export default connect(mapStateToProps, { getUser, updateData, newSimulation, exitSimulation, toggleTimelineActive  })(TelescopeSlider);



// WEBPACK FOOTER //
// ./src/components/dataViews/TelescopeSlider.js